"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLayoutScrollDetect = void 0;
const React = require("react");
const useLayoutScrollDetect = (resetAfterMs = 300, enabled = true) => {
    const [isLayoutScroll, setIsLayoutScroll] = React.useState(false);
    const isEnabledRef = React.useRef(enabled);
    const lastHeightRef = React.useRef(0);
    const resetTimerRef = React.useRef(null);
    React.useEffect(() => {
        if (!isEnabledRef.current)
            return;
        const root = document.documentElement;
        lastHeightRef.current = root.scrollHeight;
        const observer = new ResizeObserver(() => {
            const newHeight = root.scrollHeight;
            if (newHeight !== lastHeightRef.current) {
                setIsLayoutScroll(true);
                lastHeightRef.current = newHeight;
                if (resetTimerRef.current) {
                    clearTimeout(resetTimerRef.current);
                }
                resetTimerRef.current = window.setTimeout(() => {
                    setIsLayoutScroll(false);
                }, resetAfterMs);
            }
        });
        observer.observe(root);
        return () => {
            observer.disconnect();
            if (resetTimerRef.current) {
                clearTimeout(resetTimerRef.current);
            }
        };
    }, [isEnabledRef, resetAfterMs]);
    return isLayoutScroll;
};
exports.useLayoutScrollDetect = useLayoutScrollDetect;
